
      import { partytownSnippet } from '@builder.io/partytown/integration';

      document.head.innerHTML += partytownSnippet({
        forward: ['dataLayer.push'],
        lib: '/~partytown/',
        debug: false
      });
    